/*
 *  I13VENTCHAUFBOISI18n.ts
 *
 *  Created by Sébastien Hecart on 2022-08-12 12:25:09 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

export default {
  I13VENTCHAUFBOIS_SECTION_0_TITLE: "Dimensionnez les ventilations haute et basse d'une chaufferie bois",
  I13VENTCHAUFBOIS_in_puissanceh_chaufferie: 'Puissance chaufferie',
  I13VENTCHAUFBOIS_res_ventil_basse: 'Ventilation basse',
  I13VENTCHAUFBOIS_res_ventil_haute: 'Ventilation haute',
  I13VENTCHAUFBOIS_SECTION_1_TITLE: "Géométrie de l'ouvertures basse",
  I13VENTCHAUFBOIS_lowOpen_uuid: '',
  I13VENTCHAUFBOIS_in_longeur_basse: 'Longueur souhaitée',
  I13VENTCHAUFBOIS_res_lowOpen: 'Dimension basse',
  I13VENTCHAUFBOIS_SECTION_2_TITLE: "Géométrie de l'ouvertures haute",
  I13VENTCHAUFBOIS_highOpen_uuid: '',
  I13VENTCHAUFBOIS_in_longeur_haute: 'Longueur souhaitée',
  I13VENTCHAUFBOIS_res_highOpen: 'Dimension haute'
}
